import { useState } from 'react'
import { Send, Square } from 'lucide-react'
import { Input } from '@/components/ui/input'
import { Button } from '../ui/button'
// import { cn } from '../../utils' // removed unused
import { supportedProfiles, getStoredProfile } from '@/services/profileService'

interface ChatInputProps {
  onSend: (message: string, profile: string) => void,
  onProfileChange?: (profile: string) => void
  disabled?: boolean
  placeholder?: string
}

export function ChatInput({
  onSend,
  onProfileChange,
  disabled = false,
  placeholder = "Ask customer support assistant questions!",
}: ChatInputProps) {
  const [input, setInput] = useState('')
  const [selectedProfile, setSelectedProfile] = useState<string>(() => getStoredProfile())

  const handleSend = () => {
    const trimmed = input.trim()
    if (trimmed && !disabled) {
      onSend(trimmed, selectedProfile)
      setInput('')
    }
  }

  const handleProfileChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newProfile = e.target.value as string
    setSelectedProfile(newProfile)
    if (onProfileChange) {
      onProfileChange(newProfile)
    }
  }

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInput(e.target.value)
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Original enter key handling
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      const form = e.currentTarget.form
      if (form) {
        const event = new Event('submit', { cancelable: true, bubbles: true })
        form.dispatchEvent(event)
      }
    }
  }

  return (
    <div className="relative">
      <form onSubmit={handleSend} className="flex items-end space-x-2">
        {/* Profile selection dropdown */}
        <select
          value={selectedProfile}
          onChange={handleProfileChange}
          className="min-h-[44px] border border-gray-100 text-sm bg-background text-foreground px-3 focus-visible:ring-0 focus-visible:border-gray-200 placeholder:text-gray-400 outline-none"
          style={{ width: 200 }}
        >
          {supportedProfiles.map((profile) => (
            <option key={profile.key} value={profile.key}>
              {profile.label}
            </option>
          ))}
        </select>
        <div className="flex-1">
          <Input
            value={input}
            placeholder={placeholder}
            onChange={handleOnChange}
            onKeyDown={handleKeyDown}
            disabled={disabled}
            className="min-h-[44px] resize-none focus-visible:ring-0 focus-visible:border-gray-200 border-gray-200 placeholder:text-gray-400"
            autoComplete="on"
          />
        </div>
        <Button
          type="submit"
          size="icon"
          disabled={disabled}
          className="h-[44px] w-[44px] flex-shrink-0"
        >
          {disabled ? (<Square size={20} className="text-current" />) : (<Send size={20} />)}
          <span className="sr-only">
            {disabled ? 'Stop generation' : 'Send message'}
          </span>
        </Button>
      </form>
    </div>
  )
}